import { createFileRoute } from "@tanstack/react-router";
import { EmployeeListFeature } from "@/features/employee-list/EmployeeListFeature";

function EmployeesPage() {
  return <EmployeeListFeature />;
}

export const Route = createFileRoute("/employees/")({
  component: EmployeesPage,
  staticData: { authorize: true },
});
